import Vue from 'vue'
import App from './App.vue'
import axios from 'axios';
import ElementUI from 'element-ui';

import 'lib-flexible/flexible.js'

import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/main.css';

axios.defaults.baseURL = "http://43.135.50.24/api/";
// axios.defaults.baseURL = "/api/"
axios.interceptors.response.use(res => {

	if (!!res.data && res.data.Status != 1) {
		return Promise.reject(res.data.Message);
	}
	return res.data;
}, error => {
	return Promise.reject(error);
})

Vue.prototype.$axios = axios;
Vue.config.productionTip = false
Vue.use(ElementUI);
new Vue({
  render: h => h(App),
}).$mount('#app')
